module.exports = __webpack_public_path__ + "img/190918-visions-of-the-future-08_c6a8682bc618063478e711a1b6653713.5ef24fc7.jpg";